import React from 'react';
import { Calendar, Truck, Clock, MapPin } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const DeliveryEstimator = ({ inStock = true }) => {
  const settings = useSettings();
  const shippingThreshold = settings.free_shipping_threshold || 50;
  const shippingCost = settings.default_shipping_cost || 5.99;
  const today = new Date();
  const standardDelivery = new Date(today);
  standardDelivery.setDate(today.getDate() + 5);
  
  const expressDelivery = new Date(today);
  expressDelivery.setDate(today.getDate() + 2);

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });
  };

  const hoursLeft = 14 - today.getHours();
  const orderWithin = hoursLeft > 0 ? `${hoursLeft} hours` : 'tomorrow';

  if (!inStock) {
    return (
      <div className="bg-amber-50 dark:bg-amber-900/20 rounded-xl p-4">
        <div className="flex items-center gap-2 text-amber-700 dark:text-amber-400">
          <Clock className="w-5 h-5" />
          <span className="font-medium">Currently out of stock</span>
        </div>
        <p className="text-sm text-amber-600 dark:text-amber-500 mt-1">
          Sign up to be notified when this item is back in stock
        </p>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4 space-y-3">
      <div className="flex items-center gap-2">
        <MapPin className="w-4 h-4 text-gray-500" />
        <span className="text-sm text-gray-600 dark:text-gray-400">Deliver to:</span>
        <button className="text-sm font-medium text-teal-600 hover:underline">
          Update location
        </button>
      </div>

      <div className="space-y-2">
        {/* Express Delivery */}
        <div className="flex items-center justify-between p-3 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-teal-100 dark:bg-teal-900/50 rounded-lg flex items-center justify-center">
              <Truck className="w-5 h-5 text-teal-600" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-800 dark:text-white">Express Delivery</p>
              <p className="text-xs text-gray-500">Order within {orderWithin}</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm font-bold text-gray-800 dark:text-white">
              {formatDate(expressDelivery)}
            </p>
            <p className="text-xs text-gray-500">$9.99</p>
          </div>
        </div>

        {/* Standard Delivery */}
        <div className="flex items-center justify-between p-3 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center">
              <Calendar className="w-5 h-5 text-gray-600 dark:text-gray-400" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-800 dark:text-white">Standard Delivery</p>
              <p className="text-xs text-emerald-600">FREE on orders ${shippingThreshold}+</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm font-bold text-gray-800 dark:text-white">
              {formatDate(standardDelivery)}
            </p>
            <p className="text-xs text-gray-500">${shippingCost} or FREE</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryEstimator;
